import styled from "styled-components";
import { fade } from "@material-ui/core/styles";
import {
  cuideoTheme,
  COLOR_BORDER,
  COLOR_TEXT_MUTED,
} from "../../../../containers/themes/defaultTheme";
import { getOccupiedPalette } from "./WeeklyCalendarDesktop.styles";
import { OccupiedBlockKind } from "./types";

export const MobileList = styled.div`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  width: 100%;
  overflow: hidden;
  padding-top: 16px;
`;

export const MobileDayBox = styled.div`
  border: 1px solid ${COLOR_BORDER};
  border-radius: 12px;
  padding: 0.5rem 0;
  & + & {
    margin-top: 40px;
  }
`;

export const MobileDayRow = styled.div<{
  $disabled: boolean;
  $clickable?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0.5rem 1rem;
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  background: transparent;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

export const MobileDayLabel = styled.span`
  font-size: calc(0.95rem * var(--wc-font-scale, 1));
  font-weight: 600;
  color: ${cuideoTheme.palette.primary.main};
`;

export const MobileEventRow = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.4rem 1rem 0.4rem 0.5rem;
  background: transparent;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
`;

export const MobileEventTime = styled.span`
  flex: 1;
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  color: ${cuideoTheme.palette.primary.main};
`;

export const TimeSelectGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  color: ${cuideoTheme.palette.primary.main};
`;

export const TimeSelect = styled.select`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  color: ${cuideoTheme.palette.primary.main};
  border: 1px solid ${COLOR_BORDER};
  border-radius: 4px;
  padding: 4px 2px;
  background: transparent;
  outline: none;
  &:focus { border-color: ${cuideoTheme.palette.secondary.main}; }
`;

export const TimeSeparator = styled.span`
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  color: ${cuideoTheme.palette.primary.main};
  padding: 0 4px;
`;

export const MobileDeleteButton = styled.span`
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  font-weight: 600;
  color: ${cuideoTheme.palette.error.main};
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
  text-decoration: underline;
  &:hover { text-decoration: none; }
`;

// Fila de solo lectura con el horario ocupado por un contrato de la candidata.
export const MobileOccupiedRow = styled.div<{ $kind: OccupiedBlockKind }>`
  margin: 0.25rem 0.5rem;
  padding: 0.4rem 0.5rem;
  border: 1px solid ${({ $kind }) => getOccupiedPalette($kind).border};
  border-radius: 4px;
  background-image: ${({ $kind }) => getOccupiedPalette($kind).background};
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  font-weight: 600;
  color: ${({ $kind }) => getOccupiedPalette($kind).text};
  cursor: not-allowed;
`;

export const MobileHint = styled.p`
  margin: 0;
  padding: 0.45rem 1rem;
  font-size: calc(0.8rem * var(--wc-font-scale, 1));
  font-style: italic;
  color: ${COLOR_TEXT_MUTED};
`;

export const AddEventButton = styled.span`
  display: inline-block;
  margin: 0.4rem 1rem;
  font-size: calc(0.85rem * var(--wc-font-scale, 1));
  color: ${cuideoTheme.palette.secondary.main};
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
  &:hover { text-decoration: none; }
`;

export const MobileCopyButton = styled.button<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid ${({ $disabled }) => ($disabled ? COLOR_BORDER : cuideoTheme.palette.primary.main)};
  border-radius: 4px;
  color: ${({ $disabled }) => ($disabled ? COLOR_BORDER : cuideoTheme.palette.primary.main)};
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: calc(0.7rem * var(--wc-font-scale, 1));
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  padding: 2px 8px;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  &:hover {
    background: ${({ $disabled }) =>
      $disabled ? "none" : fade(cuideoTheme.palette.primary.main, 0.08)};
  }
`;
